module.exports = __webpack_public_path__ + "icons/original/large/large-c2.c8ea002cb52b8a2bb2391a8a599a1be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-c2.png
// module id = oXIE
// module chunks = app